import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const StyledLabel = styled.label`
  position: relative;
  display: inline-block;
  width: 40px;
  height: 22px;
`;

const StyledInput = styled.input`
  opacity: 0;
  width: 0;
  height: 0;
  &:checked + span {
    background-color: ${props =>
      props.theme.background[props.backgroundColor] ||
      props.backgroundColor ||
      props.theme.primary.normal};
  }
  &:checked + span:before {
    transform: translateX(18px);
  }
`;

const StyledSpan = styled.span`
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border-radius: 22px;
  background-color: ${props => props.theme.background.background700};
  transition: 0.4s;
  &:before {
    position: absolute;
    content: '';
    height: 16px;
    width: 16px;
    top: 3px;
    left: 3px;
    border-radius: 50%;
    background-color: ${props => props.theme.background.background100};
    transition: 0.4s;
  }
`;

const Switch = props => (
  <StyledLabel>
    <StyledInput type="checkbox" {...props} />
    <StyledSpan />
  </StyledLabel>
);

Switch.propTypes = {
  backgroundColor: PropTypes.string,
};

Switch.defaultProps = {
  backgroundColor: null,
};

export default Switch;
